import React, { useState } from 'react';
import './App.css';
import {VideoFeed} from './ui/VideoFeed';
import FrontCam from './assets/images/cruise-view.jpeg';
import BackCam from './assets/images/back.jpeg';
import AppView from './ui/AppView';


function AppwithFeeds () {
  const [isFullScreen, setFullscreen] = useState(<AppView/>);
  const [isLeft, setLeft] = useState(<VideoFeed src={FrontCam}/>);
  const [isRight, setRight] = useState(<VideoFeed src={BackCam}/>);
  return (
    <div className="appBackground">

      <div className="appContainer">
        <div className="bigContainer">{isFullScreen}</div>

        <div 
          className="leftAppContainer small"
          onClick={()=>{
            const fullScreen = isFullScreen;
            setFullscreen(isLeft);
            setLeft(fullScreen);
          }}
        >
          {isLeft}
        </div>
        <div 
          className="rightAppContainer small"
          onClick={()=>{
            const fullScreen = isFullScreen;
            setFullscreen(isRight);
            setRight(fullScreen);
          }}
        >
          {isRight}
        </div>
      </div>
    </div>
  );
}

export default AppwithFeeds;
